import moment from "moment/moment";
import React, { createRef } from "react";
import { Offcanvas } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";
import loadingIcon from "include/images/loader-grey.svg";
import emptyIcon from "include/images/nrf.svg";
import userIcon from "include/images/user.png";

//  Components
import Form from "common/form/form";
import Loader from "common/loader";
import { getTelegram, loadTelegramUserTransactions } from "store/telegram";
import { TELEGRAM_WALLET_TRANSACTION_AMOUNT_TYPE } from "utils/constants";
import { pluralize } from "utils/misc";

class ListingFlyer extends Form {
  scrollRef = React.createRef();
  ref = createRef(null);
  state = {
    loading: false,
    loadingMore: false,
    page: 1,
  };
  handleLoadMore = (entries) => {
    const target = entries[0];
    if (target?.isIntersecting) {
      const { telegramUserTransactions, telegramUserTransactionsTotalCount } = this.props.getTelegram;

      if (!this.state.loadingMore && telegramUserTransactions?.length < telegramUserTransactionsTotalCount) {
        this.setState({ loadingMore: true });
        const params = { page: this.state.page + 1 };

        this.props.loadTelegramUserTransactions(this.props.user?._id, params, false, (res) =>
          this.setState({ loadingMore: false, page: this.state.page + 1 }),
        );
        this.observer.disconnect();
      }
    }
  };
  observer = new IntersectionObserver(this.handleLoadMore, {
    threshold: 0.2,
  });
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
      this.setState({ loading: true });
      const params = {};

      this.props.loadTelegramUserTransactions(this.props.user?._id, params, true, (res) => {
        this.setState({ loading: false });
      });
    }
    if (!this.props.showModal && this.props.showModal !== prevProps.showModal) {
      this.setState({
        loading: false,
        loadingMore: false,
        page: 1,
      });
    }

    if (!this.props.getTelegram.loading && this.props.getTelegram.loading !== prevProps.getTelegram.loading)
      this.ref.current.complete();

    if (this.props.getTelegram.loading && this.props.getTelegram.loading !== prevProps.getTelegram.loading)
      this.ref.current.continuousStart();

    if (
      this.props.getTelegram?.telegramUserTransactions?.length <
      this.props.getTelegram?.telegramUserTransactionsTotalCount
    ) {
      console.log(this.scrollRef?.current);

      if (this.observer && this.scrollRef?.current) {
        this.observer.observe(this.scrollRef.current);
      }
    }
  };
  onRefChange = (node, i) => {
    const { telegramUserTransactions, telegramUserTransactionsTotalCount } = this.props.getTelegram;

    if (
      i === telegramUserTransactions?.length - 1 &&
      telegramUserTransactions?.length < telegramUserTransactionsTotalCount
    ) {
      this.scrollRef.current = node;
    }
  };
  render() {
    const { telegramUserTransactions, filteredCount } = this.props.getTelegram;
    const { user } = this.props;

    return (
      <>
        <Loader loaderRef={this.ref} />
        <Offcanvas
          className={"offcanvas offcanvas-end custom-offcanvas-pannel custom-offcanvas-pannel2"}
          show={this.props.showModal}
          onHide={this.props.toggleModal}
          id="rewardPannel"
          placement="right"
          name="rewardPannel"
          backdrop={true}
        >
          <Offcanvas.Header className="offCanvas-header-2">
            <div>
              <h5>User Activities </h5>{" "}
              <div className="td-img-group d-flex align-items-start m-top-2">
                <div className="td-img round-img m-right-2 pointer">
                  <img src={user?.image?.small ? process.env.REACT_APP_CDN + user.image.small : userIcon} alt="" />
                </div>
                {user?.firstName} {user?.lastName}
                <br />
                {user?.userName}
              </div>
            </div>
            <div
              className="btn_close pointer"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={this.props.toggleModal}
            >
              <img src={closeIcon} alt="" />
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="">
              <div className="fwc-body">
                {!this.state.loading && (
                  <div className="table-responsive">
                    {telegramUserTransactions?.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th>Contest</th>
                            <th>Credits</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {telegramUserTransactions?.map((activity, i) => (
                            <tr key={activity?.id} ref={(node) => this.onRefChange(node, i)}>
                              <td>
                                <div className="td-text-box upperCase">{activity.title}</div>
                              </td>{" "}
                              <td>
                                <div className="td-text-box text-uppercase">
                                  {activity?.transactionType == "DR" ? "- " : "+ "}
                                  {activity?.amount}{" "}
                                  {pluralize(
                                    activity?.amount,
                                    TELEGRAM_WALLET_TRANSACTION_AMOUNT_TYPE[activity.amountType] === "USDT",
                                    TELEGRAM_WALLET_TRANSACTION_AMOUNT_TYPE[activity.amountType],
                                  )}
                                </div>
                              </td>{" "}
                              <td>
                                <div className="td-text-box">
                                  {moment(activity.createdAt).format("MM/DD/YYYY hh:mm a")}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </div>
            {this.state.loadingMore && (
              <div className="w-100 d-flex justify-content-center load-more">
                <img src={loadingIcon} className="fa-spin" alt="" />
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadTelegramUserTransactions: (id, params, fresh, callback) =>
    dispatch(loadTelegramUserTransactions(id, params, fresh, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListingFlyer));
